/**
 * Tokens service
 */

import Resource from './resource'

export default new Resource('tokens')



// WEBPACK FOOTER //
// ./src/libraries/services/tokens.js